<template>
  <component
    :is="componentTag"
    :style="buttonElStyles"
    :target="isLink ? buttonTarget : undefined"
    :href="isLink ? applicationUrl : undefined"
    :disabled="!isLink && pending"
    class="apply-button"
    @click="handleClick"
  >
    <Transition name="slide-up" mode="out-in">
      <GlobalUISpinner v-if="pending" />
      <span v-else class="apply-text">
        {{ button.text }}
      </span>
    </Transition>
  </component>
</template>

<script>
import { buttonComputed } from "../mixins/button.js";
import GlobalUISpinner from "../GlobalUISpinner/GlobalUISpinner.vue";

export default {
  name: "GlobalUIApplyButton",
  components: {
    GlobalUISpinner,
  },
  mixins: [buttonComputed],
  props: {
    button: {
      type: Object,
      default() {
        return {};
      },
    },
    applicationUrl: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "link",
      validator: (value) => ["link", "button"].includes(value),
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["emittedClick"],
  computed: {
    componentTag() {
      return this.type === "link" ? "a" : "button";
    },
    isLink() {
      return this.type === "link";
    },
    buttonTarget() {
      const btn = this.button || {};
      const link = btn.link || {};
      const target = link.target || {};
      return target.value ? target.value : "_blank";
    },
    isHashLink() {
      return (
        typeof this.applicationUrl === "string" &&
        this.applicationUrl.charAt(0) === "#" &&
        this.applicationUrl.length > 1
      );
    },
  },
  methods: {
    handleClick(event) {
      // For hash links, let the parent handle smooth scrolling
      // but prevent default to avoid instant jump
      if (this.isHashLink) {
        event.preventDefault();
      }

      this.$emit("emittedClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.apply-button {
  --apply-button-padding-x: 30px;
  --apply-button-padding-y: 10px;
  --button-border-radius: 10px;

  cursor: pointer;

  position: relative;

  display: inline-flex;
  gap: 8px;
  align-items: center;
  justify-content: center;

  width: 350px;
  min-width: 125px;
  height: 50px;
  padding-block: var(--apply-button-padding-y);
  padding-inline: var(--apply-button-padding-x);

  font-size: 15px;
  font-weight: var(--cr-button-font-weight);
  font-style: normal;
  line-height: 15px;
  text-decoration: none;
  overflow-wrap: anywhere;

  border: 1px solid rgb(0 0 0 / 3%);

  transition: opacity 200ms ease-in-out;

  @include font-family("button");

  @include mobile {
    width: 100%;
  }

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>
